import React, { Component } from 'react'
import Snackbar from '@material-ui/core/Snackbar'

class CopyButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
    this.self = React.createRef()
    this.invisibleInput = React.createRef()
  }
  handleCloseSnackbar = () => {
    this.setState({ open: false })
  }
  copy = () => {
    this.invisibleInput.current.value = this.self.current.innerText
    this.invisibleInput.current.select()
    document.execCommand("copy")
    this.setState({open: true})
  }
  render() {
    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, {...this.props})
    );
    return (<div style={{cursor: 'pointer'}} onClick={this.copy}>
      <input ref={this.invisibleInput} style={{opacity: '0', position: 'absolute', pointerEvents: 'none', top: '-1000px'}} />
      <div ref={this.self}>
        {childrenWithProps}
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={this.state.open}
        onClose={this.handleCloseSnackbar}
        message={<span>{this.props.message || "Copied zone ID to clipboard."}</span>}
      />
    </div>)
  }
}

CopyButton.defaultProps = {
  addLabel: true,
};

export default CopyButton